export var LOGGER_NAME = 'zipy';
export var ZIPY_SDK_URL = 'https://cdn.zipy.ai/sdk/v1.0/zipy.min.umd.js';
//# sourceMappingURL=constants.js.map